import React from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { NavLink, useNavigate , useLocation } from 'react-router-dom';


const NavBar = () => {
	const location = useLocation();
	const history = useNavigate ();

	return (
		<Navbar bg='light' expand='lg' className='navbar-sjce' sticky='top'>
			<Navbar.Brand
				onClick={() => {
					history.push('/');
					window.scrollTo(0, 0);
				}}>
					<a href="https://jssatenplacements.org/"><img
					src='/jssnoidalogoicon.png'
					className='d-inline-block align-top'
					alt='JSS Noida logo'
				/></a>
				
			</Navbar.Brand>
			<div className='title'>
				<div className='heading1'>TRAINING AND PLACEMENT CELL</div>
				<div className='sub-heading'>JSS Noida</div>
			</div>
				<Navbar.Toggle aria-controls='basic-navbar-nav' />
			<Navbar.Collapse id='basic-navbar-nav'>
				<Nav className='ml-auto' style={{ color: '#000', fontWeight: 500 }}>
					<NavLink
						exact
						to='/'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						HOME
					</NavLink>
					<NavLink
						exact
						to='/about-us'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						ABOUT US
					</NavLink>
					
					<NavLink
						exact
						to='/esteemed-recruiters'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						ESTEEMED RECRUITERS
					</NavLink>
					{/* <NavDropdown
						title='WHY SJCE?'
						className={`nav-link ${
							location.pathname.includes('why-nsut') ? 'active' : ''
						}`}
						id='whyNSUT'>
						<NavLink
							exact
							to='/why-nsut/courses-offered'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							COURSES OFFERED
						</NavLink>

						<NavLink
							exact
							to='/why-nsut/past-recruiters'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							PAST RECRUITERS
						</NavLink>

						<NavLink
							exact
							to='/why-nsut/our-alumni'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							OUR ALUMNI
						</NavLink>

						<NavLink
							exact
							to='/why-nsut/our-societies'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							OUR SOCIETIES
						</NavLink>
					</NavDropdown> */}

					
					{/* <NavLink
                exact
                to="/why-nsut"
                activeStyle={{color: "#17404e"}}
                className='nav-link'
                onClick={() =>window.scrollTo(0,0)}>
                WHY NSUT?
              </NavLink> */}
					{/* <NavLink
						exact
						to='/process'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						PROCESS
					</NavLink>*/}
					{/* <NavLink
						exact
						to='/downloads'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						PAST STATS
					</NavLink>  */}
					 <NavDropdown
						title='TEAM'
						className={`nav-link ${
							location.pathname.includes('team') ? 'active' : ''
						}`}
						id='team'>
						<NavLink
							exact
							to='/team/administration'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							ADMINISTRATION
						</NavLink>
						<NavLink
							exact
							to='/team/core'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							CORE TEAM
						</NavLink>
						<NavLink
							exact
							to='/team/plsecretaries'
							className='dropdown-item'
							onClick={() => window.scrollTo(0, 0)}>
							PLACEMENT SECRETARIES
						</NavLink>
					</NavDropdown> 
				    <NavLink
						exact
						to='/contact-us'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						CONTACT US
					</NavLink>
					<NavLink
						exact
						to='/gallery'
						activeStyle={{ color: '#17404e' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						GALLERY
					</NavLink>
					<NavLink
						exact
						to='/login'
						activeStyle={{ color: 'blue' }}
						className='nav-link'
						onClick={() => window.scrollTo(0, 0)}>
						LOGIN/REGISTER
					</NavLink>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
};

export default NavBar;
